import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Policies() {
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          padding: '120px 0 80px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 50%, rgba(123, 63, 158, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(123, 63, 158, 0.1) 0%, transparent 50%)'
          }}></div>

          <div className="container" style={{ position: 'relative', zIndex: 1 }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                <div style={{
                  display: 'inline-block',
                  padding: '8px 20px',
                  backgroundColor: 'rgba(123, 91, 161, 0.9)',
                  borderRadius: '50px',
                  marginBottom: '20px',
                  animation: 'fadeInDown 0.6s ease-out'
                }}>
                  <span style={{ color: 'white', fontSize: '0.9rem', fontWeight: '600', letterSpacing: '1px' }}>
                    📋 POLICY
                  </span>
                </div>
                
                <h1 style={{
                  fontSize: '3.5rem',
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '20px',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                  animation: 'fadeInUp 0.6s ease-out',
                  lineHeight: '1.2'
                }}>
                  Equal Opportunities Policy
                </h1>
                
                <p style={{
                  fontSize: '1.2rem',
                  color: 'rgba(255, 255, 255, 0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
                  animation: 'fadeInUp 0.6s ease-out 0.2s backwards'
                }}>
                  Our commitment to equality, diversity and inclusion
                </p>

                <div style={{
                  width: '100px',
                  height: '4px',
                  background: 'linear-gradient(90deg, #B17ACC, #7B3F9E)',
                  margin: '30px auto 0',
                  borderRadius: '2px',
                  animation: 'shimmer 2s infinite, fadeInUp 0.6s ease-out 0.4s backwards',
                  backgroundSize: '200% 100%'
                }}></div>
              </div>
            </div>
          </div>

          <div style={{
            position: 'absolute',
            bottom: '-2px',
            left: 0,
            right: 0,
            height: '100px',
            background: 'linear-gradient(to top, rgba(240, 249, 255, 1) 0%, transparent 100%)',
            animation: 'floatPattern 6s ease-in-out infinite'
          }}></div>

          <style>{`
            @keyframes fadeInDown {
              from {
                opacity: 0;
                transform: translateY(-30px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
            @keyframes fadeInUp {
              from {
                opacity: 0;
                transform: translateY(30px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
            @keyframes floatPattern {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        {/* Content Section */}
        <section id="policies" className="section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                {/* Equal Opportunities Policy */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{
                    backgroundColor: '#7b5ba1',
                    color: 'white',
                    padding: '30px',
                    marginLeft: '-40px',
                    marginRight: '-40px',
                    marginTop: '-40px',
                    marginBottom: '30px',
                    textAlign: 'center'
                  }}>
                    <h2 style={{ 
                      fontSize: '2.5rem', 
                      fontWeight: '700', 
                      marginBottom: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '15px'
                    }}>
                      <span style={{ fontSize: '2rem' }}>⚖️</span> Equal Opportunities Policy
                    </h2>
                  </div>
                  
                  <div style={{ color: '#475569', fontSize: '1.1rem', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '25px' }}>
                      At DTK College, we pursue an Equal Opportunities Policy. We ensure that all students are recruited and educated on the basis of ability and are not discriminated on the grounds of race, colour, religion, creed, ethnic or national origins, disabilities, age, sex, marital status or sexual orientation.
                    </p>

                    <div style={{
                      backgroundColor: '#F5EBFA',
                      padding: '25px',
                      borderRadius: '12px',
                      borderLeft: '4px solid #B17ACC',
                      marginBottom: '25px'
                    }}>
                      <p style={{ color: '#7B3F9E', fontWeight: '600', marginBottom: 0 }}>
                        Our staff members have received training on equal opportunities and diversity issues; the acceptance and understanding of the policy is a condition of employment. All our services are available to all and delivered in an inclusive way that does not stereotype or discriminate against any particular group.
                      </p>
                    </div>

                    <p style={{ marginBottom: '25px' }}>
                      The Policy is constantly monitored by the Principal and SMT to ensure that it is consistently applied and updated in line with new legislation.
                    </p>

                    <div style={{
                      backgroundColor: '#fef3c7',
                      padding: '25px',
                      borderRadius: '12px',
                      borderLeft: '4px solid #f59e0b',
                      marginBottom: 0
                    }}>
                      <p style={{ color: '#92400e', fontWeight: '600', marginBottom: 0 }}>
                        Anyone in receipt of our training and development service who considers that DTK College has applied unequal and unfavourable treatment to him or her within the scope of this policy should please contact the Principal immediately.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default Policies;
